export default __webpack_public_path__ + "static/media/wand.15c00378.svg";